// icons/EmailBrands.js
import Icon from '@ant-design/icons';
import { SiGmail } from 'react-icons/si';

/* ---- Gmail ---- */
// const GmailSvg = () => <SiGmail />;          // pure SVG
// export const GmailIcon = props => (
//   <Icon component={GmailSvg} {...props} />   // now an AntD icon
// );

function GmailSvg() {
  return (
    <svg
      viewBox="0 0 512 512"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M511.5 446.753V65.247H0.5v381.506h511zm-73.255-78.201v74.224H79.53v-70.247l1.816-.605
           134.664-108.435 40.74 34.519 36.176-31.78 145.319 102.324zm0-13.124L301.131 259.711l137.114-118.819v214.536zM415.453
           69.215l-18.555 17.715-8.811 8.569-8.205 8.532-8.514 7.944-7.898 7.945-7.6 7.33-7.004 7.33-7.294 6.725-6.688
           6.725-12.462 12.519-11.867 11.298-5.457 5.197-4.871 5.188-5.16 4.285-4.574 4.266-8.195 7.954-3.959 3.354-3.344
           3.371-3.344 2.72-2.748 3.074-5.16 4.284-2.123 1.509-1.527 1.845-1.816.912-1.221 1.229-1.518
           1.211L101.102 68.609zM208.727 256.764L79.53 360.001l.298-212.893z"
      />
    </svg>
  );
}

export function GmailIcon(props) {
  return <Icon component={GmailSvg} {...props} />;
}

/* ---- Outlook ---- */
function OutlookSvg() {
  return (
    <svg
      viewBox="0 0 16.376 16.376"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M16.376 6.059c0-.3-.215-.544-.478-.544h-4.697v1.087h3.717L12.48 8.611l-1.279-1.048v1.379l1.003.813c.163.132.392.132.555-.001l2.661-2.157v2.873h-4.219v1.087h4.697c.263 0 .478-.243.478-.544V6.541c0-.013-.001-.025-.002-.038.001-.013.002-.026.002-.038z" />
      <path d="M5.115 10.433c.686 0 1.126-.904 1.126-2.253 0-1.119-.325-2.253-1.126-2.253-.847 0-1.16 1.149-1.16 2.253 0 1.287.406 2.253 1.16 2.253z" />
      <path d="M0 14.992l10.195.748V.637L0 1.534v13.458zm5.162-10.72c1.741 0 2.902 1.578 2.902 3.831 0 2.743-1.475 4-2.995 4-1.66 0-2.937-1.44-2.937-3.861 0-3.182 1.207-4.729 3.03-4.729z" />
    </svg>
  );
}

export function OutlookIcon(props) {
  return <Icon component={OutlookSvg} {...props} />;
}
